import { Assets, Button, Flex, ResponsiveSpacing, Text } from '@foradevelopment/fora-ui';

import { useTypedTranslation } from '../../i18n/i18n';
import { useAppSelector } from '../../redux/hooks';

type SearchFilterInfoProps = {
  amountShowing: number;
  totalAmount: number;
  clearFilter: () => void;
  marginTop?: ResponsiveSpacing;
};

export const SearchFilterInfo = ({ amountShowing, totalAmount, clearFilter, marginTop }: SearchFilterInfoProps) => {
  const { t } = useTypedTranslation();
  const ffManageEmployeeAndEmployment = useAppSelector(
    state => state.foraGlobal.settings.ffManageEmployeeAndEmployment
  );
  return (
    <Flex columnGap={20} marginTop={marginTop}>
      <Flex>
        <Text>
          {t('common.filter.foundEmployeesAmount-1', {
            searchResultAmount: amountShowing,
            totalRowsCount: totalAmount,
          })}
        </Text>
      </Flex>
      <Flex>
        <Button styleAs="link" onClick={clearFilter} color={ffManageEmployeeAndEmployment ? 'burgundy' : 'foraBlue'}>
          <Assets.MenuCloseIcon
            color={ffManageEmployeeAndEmployment ? 'burgundy' : 'foraBlue'}
            width={10}
            marginRight={6}
          />
          {ffManageEmployeeAndEmployment ? t('common.filter.clearFilterLink') : t('common.filter.clearSearchLink-1')}
        </Button>
      </Flex>
    </Flex>
  );
};
